<ng-container *transloco="let t">
  <div class="child-history page-layout">
    <div class="top-section border-r-16">
      <button type="button" class="btn btn-sm btn-outline-primary" [routerLink]="links.childrenDetail(childUuid)">
        <i class="material-symbols-rounded me-1">arrow_back_ios_new</i>
        {{ t('childHistory/backToDetail') }}
      </button>
      <div class="top-section-filters">
        <input
          class="form-control history-search"
          type="text"
          [placeholder]="t('childHistory/searchPlaceholder')"
          [formControl]="searchControl"
        />
      </div>
    </div>

    <div class="child-history-list page-layout-sub no-gutters">
      <div class="col table-wrapper">
        <table class="table mb-0">
          <thead>
            <tr>
              <th>{{ t('childHistory/date') }}</th>
              <th>{{ t('childHistory/item') }}</th>
              <th>{{ t('childHistory/oldValue') }}</th>
              <th>{{ t('childHistory/newValue') }}</th>
              <th>{{ t('childHistory/status') }}</th>
              <th class="actions-head">{{ t('childHistory/actions') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let row of rows; let i = index" [class.locked-row]="row.isLocked" [class.current-row]="row.isCurrent">
              <td [attr.data-label]="t('childHistory/date')">
                {{ row.validFrom | date : 'd. M. y' }}
                <!-- <ng-container *ngIf="isFirstInGroup(i)">
                  {{ row.validFrom | date : 'd. M. y' }}
                  <span *ngIf="row.isCurrent" class="badge bg-success ms-1">{{ t('childHistory/badgeCurrent') }}</span>
                  <span *ngIf="row.isLocked" class="badge bg-secondary ms-1">{{ t('childHistory/badgeLocked') }}</span>
                </ng-container> -->
              </td>
              <td [attr.data-label]="t('childHistory/item')">{{ fieldNameToLabel(row) }}</td>
              <td class="value-cell" [attr.data-label]="t('childHistory/oldValue')">
                {{ valueToString(row.oldValueDisplayText ?? row.oldValue) }}
              </td>
              <td class="value-cell" [attr.data-label]="t('childHistory/newValue')">
                {{ valueToString(row.newValueDisplayText ?? row.newValue) }}
              </td>
              <td class="value-cell" [attr.data-label]="row.isCurrent || row.isLocked ? t('childHistory/status') : null">
                <div class="info-wrapper">
                  <div *ngIf="row.isCurrent" class="chip chip-primary">
                    <i class="material-symbols-rounded">check</i>
                    {{ t('childHistory/badgeCurrent') }}
                  </div>
                  <div *ngIf="row.isLocked" class="chip chip-secondary">
                    <i class="material-symbols-rounded">lock</i>
                    {{ t('childHistory/badgeLocked') }}
                  </div>
                </div>
              </td>
              <td>
                <div class="actions-cell">
                  <div *ngIf="!row.isLocked" ngbDropdown container="body" class="row-actions-dropdown">
                    <button type="button" class="btn row-actions-toggle" ngbDropdownToggle (click)="$event.stopPropagation()">
                      <i class="material-symbols-rounded">more_horiz</i>
                    </button>
                    <div ngbDropdownMenu>
                      <button type="button" ngbDropdownItem [disabled]="row.isLocked" (click)="!row.isLocked && editRowDate(row)">
                        {{ t('childHistory/changeRecordDate') }}
                      </button>
                      <button
                        type="button"
                        ngbDropdownItem
                        [disabled]="row.isLocked || row.isCurrent"
                        (click)="!row.isLocked && !row.isCurrent && editRowValue(row)"
                      >
                        {{ t('childHistory/editValue') }}
                      </button>
                      <button
                        type="button"
                        ngbDropdownItem
                        [disabled]="row.isLocked || row.isCurrent"
                        (click)="!row.isLocked && !row.isCurrent && deleteRow(row)"
                      >
                        {{ t('childHistory/deleteRecord') }}
                      </button>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
            <tr *ngIf="!rows.length">
              <td colspan="6" class="text-center py-4">{{ t('childHistory/noResults') }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <app-pagination
      *ngIf="totalCount > pageSize"
      [(page)]="page"
      (pageChange)="onPageChange($event)"
      [collectionSize]="totalCount"
      [pageSize]="pageSize"
      [showLimitSelector]="true"
      (limitChange)="onLimitChange($event)"
    ></app-pagination>
  </div>
</ng-container>
